// extracted by mini-css-extract-plugin
module.exports = {"row":"Row_row__WGIQQ","col":"Row_col__i_121"};